 $(document).ready ->
  if /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)
    $('.tel').attr 'href', 'tel:+31 (0)85 401 24 37'
  $('.mobile-toggle').click (event) ->
    event.preventDefault()
    $(this).parent('header').toggleClass 'active'
    return
  return